// src/components/pdf/AdvancedStatsPage3.jsx
import React from 'react';
import { Page, Text, View } from '@react-pdf/renderer';
import styles from './styles';
import { VerticalBarChart, CommentBox } from './charts/AdvancedCharts';
import { SHOT_COLORS } from '../../utils/advancedStatsCalculator';

/**
 * Page 3 des statistiques avancées
 * GAUCHE: Coup droit + Revers par direction + commentaires
 * DROITE: Volée par direction + Longueur rallye + commentaires
 */
const AdvancedStatsPage3 = ({ match, playerName, playerCode, advancedStats, comments }) => {
  const { directionStats, rallyLengthStats } = advancedStats;
  
  const playerIndex = playerCode === 'J1' ? 'j1' : 'j2';
  
  // Préparer les données coup droit par direction
  const forehandData = directionStats.coupDroitDirections
    .map(dir => ({
      label: dir.label,
      points: directionStats.coupDroitStats[playerIndex].points[dir.code] || 0,
      fautes: directionStats.coupDroitStats[playerIndex].fautes[dir.code] || 0
    })); // SANS FILTER
  
  // Préparer les données revers par direction
  const backhandData = directionStats.reversDirections
    .map(dir => ({
      label: dir.label,
      points: directionStats.reversStats[playerIndex].points[dir.code] || 0,
      fautes: directionStats.reversStats[playerIndex].fautes[dir.code] || 0
    })); // SANS FILTER
  
  // Préparer les données volée par direction
  const volleyData = directionStats.volleeDirections
    .map(dir => ({
      label: dir.label,
      points: directionStats.volleeStats[playerIndex].points[dir.code] || 0,
      fautes: directionStats.volleeStats[playerIndex].fautes[dir.code] || 0
    })); // SANS FILTER
  
  // Préparer les données longueur rallye
  const rallyData = rallyLengthStats.categories.map(cat => ({
    label: cat.label,
    points: rallyLengthStats.stats[playerIndex].pointsGagnes[cat.code] || 0,
    fautes: rallyLengthStats.stats[playerIndex].pointsPerdus[cat.code] || 0
  }));
  
  return (
    <Page size="A4" style={styles.page}>
      <Text style={styles.sectionTitle}>Statistiques Avancées - Analyse par Direction</Text>
      
      {/* Espacement après le titre */}
      <View style={{ height: 10 }} />
      
      {/* Layout 2 colonnes */}
      <View style={{ flexDirection: 'row', gap: 20, marginTop: 10 }}>
        {/* COLONNE GAUCHE */}
        <View style={{ flex: 1 }}>
          {/* Coup droit par direction */}
          <VerticalBarChart
            data={forehandData}
            title="Points et fautes en coup droit par direction"
            color={SHOT_COLORS['Coup Droit']}
          />
        </View>
        
        {/* COLONNE DROITE */}
        <View style={{ flex: 1 }}>
          {/* Volée par direction */}
          <VerticalBarChart
            data={volleyData}
            title="Points et fautes à la volée par direction"
            color={SHOT_COLORS['Volée']}
          />
        </View>
      </View>
      
      {/* Commentaire commun aux graphes coup droit et volée - pleine largeur, APRÈS ces 2 graphes */}
      {comments?.bloc5 && (
        <View style={{ marginTop: -10 }}>
          <CommentBox comment={comments.bloc5} />
        </View>
      )}
      
      {/* Espacement entre les blocs de graphes */}
      <View style={{ height: 15 }} />
      
      {/* Layout 2 colonnes pour les 2 derniers graphes */}
      <View style={{ flexDirection: 'row', gap: 20 }}>
        {/* COLONNE GAUCHE */}
        <View style={{ flex: 1 }}>
          {/* Revers par direction */}
          <VerticalBarChart
            data={backhandData}
            title="Points et fautes en revers par direction"
            color={SHOT_COLORS['Revers']}
          />
        </View>
        
        {/* COLONNE DROITE */}
        <View style={{ flex: 1 }}>
          {/* Longueur de rallye - utiliser couleur verte pour gagné, rouge pour perdu */}
          <VerticalBarChart
            data={rallyData}
            title="Points gagnés / perdus selon la longueur du rallye"
            color="#4CAF50"
          />
        </View>
      </View>
      
      {/* Commentaire commun aux graphes revers et rallye - pleine largeur, APRÈS ces 2 graphes */}
      {comments?.bloc6 && (
        <View style={{ marginTop: -10 }}>
          <CommentBox comment={comments.bloc6} />
        </View>
      )}
    </Page>
  );
};

export default AdvancedStatsPage3;